import React from "react"
import { Dialog, Grid } from "@material-ui/core"

/**
 * Autoplay won't work
 * https://developers.google.com/youtube/iframe_api_reference#Mobile_considerations
 */
const playerOptions =
  "?autoplay=0&rel=0&modestbranding=1&controls=0&autohide=1&showinfo=0"

export const VideoPlayer = ({ classes, videoUrl, open, handleClose }) => {
  const url = `${videoUrl + playerOptions}`
  return (
    <Grid container>
      <Grid item xs={12}>
        <Dialog open={open} onClose={handleClose}>
          <iframe
            title={url}
            className={classes.videoPlayer}
            src={url}
            frameBorder="0"
          />
        </Dialog>
      </Grid>
    </Grid>
  )
}
